import config from "../../utils/config";

const Database = {
  set(key, value) {
    localStorage.setItem(`${config.perfix}${key}`, value);
  },
  get(key) {
    return localStorage.getItem(`${config.perfix}${key}`);
  },
};

export default Database;
